export const ADHOC_TEXT_FIELDS = [
    'emailSubject',
    'emailContent'
];
export const EMPTY_RICH_TEXT_FIELDS = [];
